import { render, staticRenderFns } from "./TournamentPlayerType.vue?vue&type=template&id=60d5d08f&"
import script from "./TournamentPlayerType.vue?vue&type=script&lang=js&"
export * from "./TournamentPlayerType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports